export default __webpack_public_path__ + "static/media/filter-solid.8b48035f.svg";